import { Alert, AlertIcon, Button, Heading, theme, VStack } from '@chakra-ui/react';
import { AnimatedCheckmark } from '@common/components/AnimatedCheckmark';
import { confetti } from '@common/components/Confetti';
import { useBankAccountsModel } from '@common/models/BankAccountsModel';
import { usePricingPlanModel } from '@common/models/PricingPlanModel';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';
import { ROUTES } from 'src/apps/invest/config';
import { useCheckoutSFRViewModel } from '../../models/CheckoutSFRViewModel';
import Summary from '../components/Summary';

export const CheckoutSFRCongratsPage: React.FC = () => {
  const viewModel = useCheckoutSFRViewModel();
  const bankAccountsModel = useBankAccountsModel();
  const bankAccount = bankAccountsModel.getDefaultBankAccount();
  const pricingPlanModel = usePricingPlanModel();
  const thumbnail = viewModel.property?.sfr?.info?.images?.[0];
  const shares = viewModel.amount / Number(viewModel.property?.share_price ?? 0);
  useEffect(confetti, []);

  return (
    <UI>
      <VStack width="full" justifyContent={'center'} gap="20px" padding={['0px', '50px']} maxW="960px" margin="0 auto">
        <Heading
          fontSize={['32px', '32px', '32px', '48px']}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontWeight="normal"
          textAlign="center">
          Congrats on your <br />
          {currency.format(viewModel.amount)} investment!
        </Heading>
        <AnimatedCheckmark fill="transparent" strokeColor={theme.colors.blue[500]} strokeWidth={6} size={123} />
        <Alert status="info">
          <AlertIcon />
          We will notify you once it is approved and we transfer the money from your bank.
        </Alert>
        <Summary.Container label="Investment Summary">
          <Summary.Item
            label={viewModel.property?.display_name ?? ''}
            value={viewModel.property?.sfr?.info?.address ?? ''}
            image={thumbnail?.url}
          />
          {viewModel.property?.share_price && <Summary.Item label="Shares" value={`${shares}`} />}
          <Summary.Item label="Amount" value={currency.format(viewModel.amount)} />

          <Summary.Item
            label="Account"
            value={`${bankAccount?.name} - ${bankAccount?.account_type} (...${bankAccount?.account_number || ''})`}
          />
          {viewModel.pricingPlan && (
            <Summary.Item label="Pricing Plan" value={pricingPlanModel.getFriendlyName(viewModel.pricingPlan)} />
          )}
        </Summary.Container>
        <TextBlock opacity={0.65}>
          As always, you can review all your investments in{' '}
          <Link to={ROUTES.activity} style={{ color: theme.colors.blue[500] }}>
            Activity
          </Link>{' '}
          or the{' '}
          <Link to={ROUTES.dashboard} style={{ color: theme.colors.blue[500] }}>
            Dashboard
          </Link>{' '}
          for recent activity.
        </TextBlock>
        <Button as={Link} to={ROUTES.dashboard} size="lg" padding="30px">
          Back To Dashboard
        </Button>
      </VStack>
    </UI>
  );
};
